export const Body = () => (
    <svg
        viewBox="0 0 280 260"
        style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: 280,
            height: 260,
            zIndex: 1,
            filter: 'drop-shadow(0 8px 30px rgba(120,120,240,0.3))',
        }}
    >
        <defs>
            <linearGradient id="bodyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#b0b0fa" />
                <stop offset="50%" stopColor="#8b8bf5" />
                <stop offset="100%" stopColor="#7575e8" />
            </linearGradient>
        </defs>
        <path
            d="
      M 90,25 L 190,25 Q 205,25 212,38
      L 258,117 Q 265,130 258,143
      L 212,222 Q 205,235 190,235
      L 90,235 Q 75,235 68,222
      L 22,143 Q 15,130 22,117
      L 68,38 Q 75,25 90,25 Z
    "
            fill="url(#bodyGrad)"
        />
    </svg>
);
